import { useState } from 'react';
import { PlusIcon, MinusIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { RESOURCE_SECTIONS } from '../constants/resources';

const ResourceSection = ({ section, isOpen, onToggle }) => {
  const panelId = `resource-panel-${section.id}`;
  const buttonId = `resource-button-${section.id}`;

  return (
    <div className="border-b border-fossilGrey last:border-b-0">
      <h4 className="m-0">
        <button
          id={buttonId}
          type="button"
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-controls={panelId}
          className={clsx(
            'flex w-full items-center justify-between px-4 py-3 text-left text-base font-semibold transition-colors',
            isOpen ? 'bg-blue text-white' : 'bg-white text-blue hover:bg-fossilGrey',
          )}
        >
          {section.title}
          {isOpen ? <MinusIcon className="h-5 w-5" /> : <PlusIcon className="h-5 w-5" />}
        </button>
      </h4>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        inert={!isOpen}
        className={clsx(
          'grid transition-[grid-template-rows] duration-300 ease-in-out',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        )}
      >
        <div className="overflow-hidden">
          <div className="bg-white px-4 py-3">
            {section.links.length ? (
              <ul className="m-0 flex list-none flex-col gap-3 p-0">
                {section.links.map(link => (
                  <li key={link.url}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-semibold text-slateBlue underline hover:text-blue"
                    >
                      {link.title}
                    </a>
                    {link.description && (
                      <p className="m-0 mt-1 text-sm text-gray-700">{link.description}</p>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="m-0 text-sm italic text-gray-500">Resources coming soon.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const Resources = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = id => setOpenSections(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <div className="overflow-hidden rounded-md border border-fossilGrey">
      {RESOURCE_SECTIONS.map(section => (
        <ResourceSection
          key={section.id}
          section={section}
          isOpen={!!openSections[section.id]}
          onToggle={() => toggleSection(section.id)}
        />
      ))}
    </div>
  );
};
